export default __webpack_public_path__ + "static/media/gift2.deba49e1.svg";